import { PreviewMediaType } from '@/types';

import type { LibraryItem, Preset } from '@/types';

/**
 * Builds a full `Preset` from a cached library grid item (and its section slug),
 * so the create flow can start without the extra `/flow-landings/slug` request.
 *
 * The grid item already carries the same `uploadItems`/`textItems` the detail
 * endpoint returns (same CMS transform). The two gaps we synthesize: the array
 * form of media (the item has a single `media`) and `category` (the section slug).
 */
const buildPresetFromLibraryItem = (
  item: LibraryItem,
  sectionSlug: string
): Preset => {
  const isVideo = item.type === PreviewMediaType.VIDEO;

  return {
    flowId: item.flowId ?? '',
    presetCreditCount: item.presetCreditCount ?? null,
    type: item.type,
    title: item.title,
    description: item.description,
    slug: item.slug,
    category: sectionSlug,
    textItems: item.textItems ?? [],
    uploadItems: item.uploadItems ?? [],
    image: isVideo ? [] : [{ media: item.media }],
    video: isVideo ? [{ media: item.media }] : [],
  };
};

export default buildPresetFromLibraryItem;
